import React from 'react'
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <circle cx="12" cy="12" r="12" />
  </React.Fragment>,
  'CircleIcon'
)
